import React, { useState, useCallback } from 'react';
import Modal from '@tls/ui-modal';
import { Input } from '@pwc/appkit-react/lib/Input';

import styles from './syncReturnModal.module.scss';

interface SyncReturnModalProps {
  visible: boolean;
  hideModal: () => void;
  onConfirm: (authorizerName: string) => void;
  isLoading?: boolean;
}

const SyncReturnModal = ({ visible, hideModal, onConfirm, isLoading }: SyncReturnModalProps) => {
  const [authorizerName, setAuthorizerName] = useState('');
  const [inputError, setInputError] = useState<string | null>(null);

  const validateAuthorizerName = useCallback((value: string) => {
    if (!value.trim()) return 'Authorizer Name is required';
    if (!/^[a-zA-Z\s]+$/.test(value)) return 'Only letters and spaces are allowed';
    return null;
  }, []);

  const onChange = (value: string) => {
    console.log('value_: ', value);
    const val = value;
    setAuthorizerName(val);
    setInputError(validateAuthorizerName(val));
  };

  const onConfirmClick = () => {
    const error = validateAuthorizerName(authorizerName);
    setInputError(error);
    if (!error) {
      onConfirm(authorizerName.trim());
      setAuthorizerName('');
    }
  };

  const onCancelClick = () => {
    setAuthorizerName('');
    setInputError(null);
    hideModal();
  };

  return (
    <Modal title="Sync Return" visible={visible} closeAction={onCancelClick}>
      <p>Are you sure you want to sync this return with TR?</p>

      <label htmlFor="authorizer-name" className={styles.label}>
        Authorizer Name
      </label>
      <Input
        id="authorizer-name"
        value={authorizerName}
        onChange={onChange}
        hasError={!!inputError}
        errMsg={inputError || undefined}
        disabled={isLoading}
      />

      <div className={styles.buttonsContainer}>
        <button onClick={onCancelClick} disabled={isLoading} className={styles.cancelButton}>
          Cancel
        </button>
        <button
          onClick={onConfirmClick}
          disabled={!!inputError || !authorizerName.trim() || isLoading}
          className={styles.confirmButton}
        >
          {isLoading ? 'Syncing...' : 'Confirm'}
        </button>
      </div>
    </Modal>
  );
};

export default SyncReturnModal;
